module.exports = __webpack_public_path__ + "img/04-3-4系统运维.8dfca1bb.png";